import { render, staticRenderFns } from "./v-hero-slider.vue?vue&type=template&id=174fb74f&scoped=true&"
import script from "./v-hero-slider.vue?vue&type=script&lang=js&"
export * from "./v-hero-slider.vue?vue&type=script&lang=js&"
import style0 from "./v-hero-slider.vue?vue&type=style&index=0&id=174fb74f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174fb74f",
  null
  
)

export default component.exports